import {useTranslation} from "react-i18next";
import {SubmitHandler, useForm} from "react-hook-form";
import {PricingInputs} from "../../../@types/pricingFormResources.tsx";
import {sendPricingForm} from "../../../api";
import FormColumns from "./FormColumns.tsx";
import React, {useRef} from "react";
import {
    buildPricingPayload,
    handleEmptyValues,
    validatePricingFormAndReturnErrorCount
} from "../../../helpers/pricing/formHelper.ts";
import {FormInput} from "../../../@types/pricingFormInputsResources.ts";
import {PricingFormPageEnum} from "../../../enum/pricing-form-page/pricingFormPageEnum.ts";
import {getUTMParameters} from "../../../helpers/utm/utmHelper.ts";
import md5 from "md5";

const PricingForm = (
    {
        setSubmit,
        captcha,
        setCaptcha,
        setConnectionError,
        subject,
        page,
        formContainerRef,
        config
    }:
        {
            setSubmit: (arg0: boolean) => void,
            captcha: boolean|null,
            setCaptcha: (arg0: boolean|null) => void,
            setConnectionError: (arg0: boolean) => void,
            subject: string,
            page: PricingFormPageEnum,
            formContainerRef: React.RefObject<HTMLDivElement>,
            config: FormInput[]
        }
) => {

    const {t, i18n} = useTranslation();
    const formRef = useRef<HTMLFormElement>(null);

    const {register, handleSubmit} = useForm<PricingInputs>();

    const onSubmit: SubmitHandler<PricingInputs> = async (data) => {

        setConnectionError(false);

        const errorsCount = validatePricingFormAndReturnErrorCount(data, captcha, formContainerRef.current, setCaptcha);

        if (errorsCount > 0) {
            return formContainerRef.current?.scrollIntoView();
        }

        try {
            await sendPricingForm(buildPricingPayload(handleEmptyValues(data), i18n.language, subject));
        } catch (error) {
            setConnectionError(true);
            return formContainerRef.current?.scrollIntoView();
        }

        const utmParameters = getUTMParameters();
        const commonEventData = {
            'user_id': md5(data.email),
            'event_time': new Date().toISOString(),
            ...utmParameters
        }

        if (page === PricingFormPageEnum.PRICING_PAGE) {
            fbq('track', 'Lead', {content_type: "gautikaina"});
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'pricing_form_submission',
                'formLocation': 'ikainiai',
                ...commonEventData
            });
        }

        if (page === PricingFormPageEnum.SOLUTIONS_SHOPIFY_PAGE) {
            fbq('track', 'Lead', {content_type: "gautikaina"});
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'shopify_form_submission',
                'formLocation': 'sprendimai-shopify',
                ...commonEventData
            });
        }

        setSubmit(true);
        return formContainerRef.current?.scrollIntoView();
    }

    return (
        <>
            <div className="col-lg-6 bg-white py-5 px-md-5">
                <div className="text-center mb-5">
                    <h2 className="mb-0 fs-4">{t('get_offer')}</h2>
                </div>
                <form ref={formRef} id="pricing-form" onSubmit={handleSubmit(onSubmit)} className="prices-form">
                    <FormColumns config={config}
                                 register={register}
                                 setCaptcha={setCaptcha}
                                 linkClassName={'text-decoration-underline text-blue'} />
                    <div className="row mt-3">
                        <div className="buttons">
                            <button type="submit"
                                    className="button opy-bg-orange rounded text-blue-dark fw-medium py-3 px-5 w-100">
                                {t('get_offer')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default PricingForm;
